import client from './client';

export const lokiApi = {
  async getStatus() {
    const { data } = await client.get('/api/loki/status');
    return data;
  },

  async listLabels(params = {}) {
    const { data } = await client.get('/api/loki/labels', { params });
    return data;
  },

  async listLabelValues(name, params = {}) {
    const { data } = await client.get(`/api/loki/labels/${encodeURIComponent(name)}/values`, {
      params,
    });
    return data;
  },

  async query(params) {
    const { data } = await client.get('/api/loki/query', { params });
    return data;
  },

  tailUrl({ query, start, delayFor, limit } = {}) {
    const qs = new URLSearchParams();
    if (query) qs.set('query', query);
    if (start) qs.set('start', String(start));
    if (delayFor) qs.set('delay_for', String(delayFor));
    if (limit) qs.set('limit', String(limit));
    return `/api/loki/tail?${qs.toString()}`;
  },
};
